<template>
  <Layout>
    <PageHeader :title="title" :items="braedcrumb" />
    <div>
      <b-row>
        <b-col sm="12" lg="5">
          <b-card class="CardMain">
            <b-row>
              <b-col>
                <table>
                  <tr>
                    <td style="width:70%">{{ $t("docnumber") }}:</td>
                    <td style="width:30%">
                      <b>{{ RegulationDetail.docnumber }}</b>
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t("docdate") }}:</td>
                    <td>
                      <b>{{ RegulationDetail.docdate }}</b>
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t("finyear") }}:</td>
                    <td>
                      <b>{{ RegulationDetail.finyear }}</b>
                    </td>
                  </tr>
                  <!-- <tr>
                    <td>{{ $t("detailinfo") }}:</td>
                    <td>
                      <b>{{ RegulationDetail.detailinfo }}</b>
                    </td>
                  </tr> -->
                  <tr>
                    <td>{{ $t("organization") }}:</td>
                    <td>
                      <b>{{ RegulationDetail.organizationname }}</b>
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t("settlecodelevel") }}:</td>
                    <td>
                      <b>{{ RegulationDetail.settlecodelevel }}</b>
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t("functionalitemcode") }}:</td>
                    <td>
                      <b>{{
                          RegulationDetail.functionalitemcode,
                      }}</b>
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t("status") }}:</td>
                    <td>
                      <span
                        :class="
                          `badge rounded-pill bg-${getColorStatus(
                            RegulationDetail
                          )} ms-1`
                        "
                      >
                        {{ RegulationDetail.statusname }}
                      </span>
                    </td>
                  </tr>
                </table>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
        <b-col sm="12" lg="5">
          <b-card class="TableCard">
            <table>
              <tbody>
                <tr>
                  <td style="width:40%">{{ $t("detailinfo") }}:</td>
                  <td>
                    <b>{{ RegulationDetail.detailinfo }}</b>
                  </td>
                </tr>
              </tbody>
            </table>
          </b-card>
        </b-col>
        <b-col class="text-right">
          <b-button
            @click="$router.go(-1)"
            variant="danger"
            class="mb-1"
            style="width:100%"
            ><i class="dripicons-arrow-thin-left"></i>
            {{ $t("back") }}</b-button
          >

          <b-button
            v-if="
              $can('PurchaseRequisitionTotalApprove', 'permissions') &&
                RegulationDetail.CanApprove === true
            "
            @click="OpenApproveModal"
            variant="success"
            class="mb-1"
            style="width:100%"
            ><i class="bx bx-check"></i> {{ $t("Approve") }}</b-button
          >
          <b-button
            v-if="
              $can('PurchaseRequisitionTotalCancelApproval', 'permissions') &&
                RegulationDetail.CanCancelApprove === true
            "
            @click="OpenCancelApprovalModal"
            variant="danger"
            class="mb-1"
            style="width:100%"
            ><i class="bx bx-check"></i> {{ $t("CancelApproval") }}</b-button
          >

          <b-button
            @click="OpenSideBar"
            variant="info"
            class="mb-1"
            style="width:100%"
            ><i class="bx bx-history"></i> {{ $t("history") }}</b-button
          >
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card class="TableCard">
            <b-tabs pills>
              <b-tab :title="$t('Tables')">
                <b-table
                  :fields="fields"
                  responsive
                  :busy="isLoading"
                  head-row-variant="info"
                  sticky-header="60vh"
                  no-border-collapse
                  striped
                  no-footer-sorting
                  :foot-clone="true"
                  bordered
                  small
                  :items="RegulationDetailTables"
                  class="text-center mt-3"
                >
                  <template #foot(purchasequantity)> {{ $t("") }}</template>
                  <template #foot(purchaseprice)> {{ $t("") }}</template>
                  <template #foot(itemofexpensename)> {{ $t("") }}</template>
                  <template #foot(organizationaccountname)>
                    {{ $t("") }}</template
                  >
                  <template #foot(purchasebase)> {{ $t("") }}</template>
                  <template #foot(unitofmeasurename)> {{ $t("") }}</template>
                  <template #foot(purchasemonth)> {{ $t("") }}</template>
                  <template #foot(productname)> {{ $t("") }}</template>
                  <template #foot(productcategoryname)> {{ $t("") }}</template>
                  <template #foot(id)> {{ $t("Total") }}</template>
                  <template #foot(purchasesum)>
                    <div class="text-right">
                      {{
                        $options.filters.currency(total.totalsum, {
                          symbol: "  ",
                          fractionCount: 2,
                        })
                      }}
                    </div>
                  </template>
                  <template #cell(purchasesum)="{item}">
                    {{
                      $options.filters.currency(item.purchasesum, {
                        symbol: "  ",
                        fractionCount: 2,
                      })
                    }}
                  </template>
                  <template #cell(purchasequantity)="{item}">
                    {{
                      $options.filters.currency(item.purchasequantity, {
                        symbol: "  ",
                        fractionCount: 2,
                      })
                    }}
                  </template>
                  <template #cell(purchaseprice)="{item}">
                    {{
                      $options.filters.currency(item.purchaseprice, {
                        symbol: "  ",
                        fractionCount: 2,
                      })
                    }}
                  </template>
                </b-table>
              </b-tab>
              <b-tab :title="$t('MonthForOrgTables')">
                <b-table
                  :fields="fieldsOrg"
                  responsive
                  :busy="isLoading"
                  head-row-variant="info"
                  sticky-header="60vh"
                  no-border-collapse
                  striped
                  no-footer-sorting
                  :foot-clone="true"
                  bordered
                  small
                  :items="RegulationDetailTablesOrg"
                  class="text-center mt-3"
                >
                  <template #foot(organizationaccountname)>
                    {{ $t("") }}</template
                  >
                  <template #foot(organizationname)> {{ $t("") }}</template>
                  <template #foot(purchasemonth)> {{ $t("") }}</template>
                  <template #foot(productname)> {{ $t("") }}</template>
                  <template #foot(docdate)> {{ $t("") }}</template>
                  <template #foot(docnumber)> {{ $t("Total") }}</template>
                  <template #foot(purchasesum)>
                    <div class="text-right">
                      {{
                        $options.filters.currency(total.totalpurchasesum, {
                          symbol: "  ",
                          fractionCount: 2,
                        })
                      }}
                    </div>
                  </template>
                  <template #cell(purchasemonth)="{item}">
                    {{
                      $options.filters.currency(item.purchasemonth, {
                        symbol: "  ",
                        fractionCount: 2,
                      })
                    }}
                  </template>
                </b-table>
              </b-tab>
            </b-tabs>
          </b-card>
        </b-col>
      </b-row>
      <b-sidebar width="400px" no-header v-model="SideBar" right shadow>
        <div class="px-3 py-2">
          <div class="row" style="height:800px;overflow-y:auto">
            <div class="col-lg-12">
              <div class="card">
                <div class="card-body">
                  <div class>
                    <ul
                      v-for="(item, index) in RegulationDetailHistory"
                      :key="index"
                      class="verti-timeline list-unstyled"
                    >
                      <li class="event-list">
                        <div class="event-timeline-dot">
                          <i class="bx bx-right-arrow-circle"></i>
                        </div>
                        <div class="media">
                          <div class="me-3">
                            <i class="bx bx-copy-alt h2 text-primary"></i>
                          </div>
                          <div class="media-body">
                            <div>
                              <table>
                                <tr>
                                  <td>
                                    <h5>{{ item.organizationinfo }}</h5>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <p class="text-muted">
                                      {{ item.dateofcreated }}
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <p>
                                      {{ item.userinfo }} -
                                      <b> {{ item.username }} </b> - <br />
                                      <span
                                        :class="
                                          `badge rounded-pill bg-${getColor(
                                            item
                                          )} ms-1`
                                        "
                                      >
                                        {{ item.statusname }}
                                      </span>
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <p v-if="item.statusname === 'Отклонен'">
                                      <span
                                        :class="
                                          `badge rounded-pill bg-${getColor(
                                            item
                                          )} ms-1`
                                        "
                                      >
                                        {{ $t("ReasonOfCancel") }}
                                      </span>
                                      : {{ item.adddata }}
                                    </p>
                                  </td>
                                </tr>
                              </table>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <template #footer="{ hide }">
          <div class="d-flex text-light align-items-center px-3 py-2">
            <b-button style="width:100%" variant="danger" @click="hide"
              ><i class="dripicons-arrow-thin-left"></i
              >{{ $t("back") }}</b-button
            >
          </div>
        </template>
      </b-sidebar>

      <b-modal
        v-model="ApproveModal"
        no-close-on-backdrop
        hide-footer
        :title="$t('Approve')"
      >
        <h4>{{ $t("WantApprove") }}</h4>

        <b-row class="mt-2">
          <b-col class="text-right d-flex justify-content-end">
            <b-button
              variant="outline-danger"
              @click="ApproveModal = false"
              style="margin-right:5px"
              >{{ $t("no") }}</b-button
            >
            <b-button @click="Approve" variant="outline-success"
              ><b-spinner v-if="ApproveLoading" small></b-spinner
              >{{ $t("yes") }}</b-button
            >
          </b-col>
        </b-row>
      </b-modal>
      <b-modal
        v-model="CancelApprovalModal"
        no-close-on-backdrop
        hide-footer
        :title="$t('CancelApproval')"
      >
        <h4>{{ $t("WantCancelApproval") }}</h4>

        <b-row class="mt-2">
          <b-col class="text-right d-flex justify-content-end">
            <b-button
              variant="outline-danger"
              @click="CancelApprovalModal = false"
              style="margin-right:5px"
              >{{ $t("no") }}</b-button
            >
            <b-button @click="CancelApproval" variant="outline-success"
              ><b-spinner v-if="CancelApprovalLoading" small></b-spinner
              >{{ $t("yes") }}</b-button
            >
          </b-col>
        </b-row>
      </b-modal>
    </div>
  </Layout>
</template>
<script>
import Layout from "../../../router/layouts/main.vue";
import PageHeader from "@/components/page-header";
import PurchaseRequisitionTotalService from "@/services/document/purchaserequisitiontotal.service";
import TimeLine from "../../../router/views/utility/timeline.vue";
import Multiselect from "vue-multiselect";
export default {
  components: {
    Multiselect,
    Layout,
    PageHeader,
    TimeLine,
  },
  data() {
    return {
      title: this.$t("PurchaseRequisitionTotal"),
      braedcrumb: [
        {
          text: this.$t("Document"),
        },
        {
          text: this.$t("PurchaseRequisitionTotal"),
          active: true,
        },
      ],
      fields: [
        {
          key: "id",
          label: this.$t("id"),
          tdClass: "text-right",
          sortable: true,
          thStyle: { width: "5% !important" },
        },
        {
          key: "productenktcode",
          label: this.$t("productcategory"),
          tdClass: "text-left",
          sortable: true,
          thStyle: { width: "15% !important" },
        },
        {
          key: "productname",
          label: this.$t("product"),
          tdClass: "text-left",
          sortable: true,
          thStyle: { width: "10% !important" },
        },
        // {
        //   key: "unitofmeasurename",
        //   label: this.$t("unitofmeasure"),
        //   tdClass: "text-left",
        //   sortable: true,
        //   thStyle: { width: "10% !important" },
        // },
        {
          key: "itemofexpensecode",
          label: this.$t("itemofexpense"),
          tdClass: "text-left",
          thStyle: { width: "10% !important" },
          sortable: true,
        },
        // {
        //   key: "purchasemonth",
        //   label: this.$t("purchasemonth"),
        //   tdClass: "text-right",
        //   thStyle: { width: "5% !important" },
        //   sortable: true,
        // },
        {
          key: "purchasequantity",
          label: this.$t("purchasequantity"),
          tdClass: "text-right",
          sortable: true,
          thStyle: { width: "5% !important" },
        },
        {
          key: "purchaseprice",
          tdClass: "text-right",
          label: this.$t("purchaseprice"),
          thStyle: { width: "10% !important" },
          sortable: true,
        },
        {
          key: "purchasesum",
          label: this.$t("purchasesum"),
          tdClass: "text-right",
          sortable: true,
          thStyle: { width: "10% !important" },
        },
        // {
        //   key: "actions",
        //   label: this.$t("actions"),
        //   thClass: "text-center",
        //   thStyle: { width: "5% !important" },
        //   sortable: true,
        // },
      ],
      fieldsOrg: [
        {
          key: "docnumber",
          label: this.$t("docnumber"),
          tdClass: "text-right",
          thStyle: { width: "5% !important" },
          sortable: true,
        },
        {
          key: "docdate",
          label: this.$t("docdate"),
          tdClass: "text-right",
          sortable: true,
          thStyle: { width: "5% !important" },
        },
        {
          key: "organizationname",
          label: this.$t("organization"),
          tdClass: "text-left",
          thStyle: { width: "15% !important" },
          sortable: true,
        },
        {
          key: "organizationaccountname",
          label: this.$t("organizationaccount"),
          tdClass: "text-right",
          sortable: true,
          thStyle: { width: "10% !important" },
        },
        {
          key: "purchasemonth",
          label: this.$t("purchasemonth"),
          tdClass: "text-right",
          thStyle: { width: "10% !important" },
          sortable: true,
        },
        {
          key: "purchasesum",
          label: this.$t("purchasesum"),
          tdClass: "text-right",
          sortable: true,
          thStyle: { width: "10% !important" },
        },
      ],
      CancelApprovalModal: false,
      CancelApprovalLoading: false,
      ApproveModal: false,
      ApproveLoading: false,
      SideBar: false,
      items: [],
      PurchaseRequisition: {},
      PurchaseRequisitionTable: [],
      isLoading: false,
      RegulationDetailHistory: [],
      RegulationDetail: {},
      RegulationDetailTables: [],
      RegulationDetailTablesOrg: [],
      tabrow: {},
      total: { totalsum: 0, totalpurchasesum: 0 },

      GetAllPurchaseBaseList: [],
    };
  },
  created() {
    this.lang = localStorage.getItem("locale") || "ru";
    this.show = true;

    this.Refresh();
  },
  directives: {},
  methods: {
    Refresh() {
      PurchaseRequisitionTotalService.GetDetail(this.$route.params.id).then(
        (res) => {
          this.RegulationDetail =
            res.data.ParentContribRequestForView.PurchaseRequisitionTotal;
          this.RegulationDetailHistory =
            res.data.ParentContribRequestForView.History;
          this.RegulationDetailTables =
            res.data.ParentContribRequestForView.PurchaseRequisitionTotal.Tables;
          this.RegulationDetailTablesOrg =
            res.data.ParentContribRequestForView.PurchaseRequisitionTotal.OrgTables;
          this.calculate();
        }
      );
    },
    calculate() {
      this.total = {
        totalsum: 0,
        totalpurchasesum: 0,
      };

      for (var i = 0; i < this.RegulationDetailTables.length; i++) {
        this.total.totalsum += 1 * this.RegulationDetailTables[i].purchasesum;
      }
      for (var j = 0; j < this.RegulationDetailTablesOrg.length; j++) {
        this.total.totalpurchasesum +=
          1 * this.RegulationDetailTablesOrg[j].purchasesum;
      }
    },

    OpenApproveModal() {
      this.ApproveModal = true;
    },
    OpenCancelApprovalModal() {
      this.CancelApprovalModal = true;
    },

    getColor(item) {
      if (item.statusname === "Создан") {
        return "primary";
      } else if (item.statusname === "Изменен") {
        return "info";
      } else if (item.statusname === "Отклонен") {
        return "danger";
      } else if (item.statusname === "Отменено") {
        return "danger";
      } else if (item.statusname === "Утвержден") {
        return "success";
      } else if (item.statusname === "Отправлен") {
        return "warning";
      } else {
        return "primary";
      }
    },
    getColorStatus(RegulationForNextYearDetail) {
      if (RegulationForNextYearDetail.statusname === "Создан") {
        return "primary";
      } else if (RegulationForNextYearDetail.statusname === "Изменен") {
        return "info";
      } else if (RegulationForNextYearDetail.statusname === "Отклонен") {
        return "danger";
      } else if (RegulationForNextYearDetail.statusname === "Отменено") {
        return "danger";
      } else if (RegulationForNextYearDetail.statusname === "Утвержден") {
        return "success";
      } else if (RegulationForNextYearDetail.statusname === "Оценен") {
        return "secondary";
      } else if (RegulationForNextYearDetail.statusname === "Одобрен") {
        return "success";
      } else if (RegulationForNextYearDetail.statusname === "Отправлен") {
        return "warning";
      } else {
        return "primary";
      }
    },

    OpenSideBar() {
      this.SideBar = true;
    },

    Approve() {
      this.ApproveLoading = true;
      PurchaseRequisitionTotalService.Approve(this.$route.params.id)
        .then((res) => {
          this.ApproveLoading = false;
          this.$notification(this.$t("ApproveSuccess"), "success");
          this.ApproveModal = false;
          setTimeout(() => {
            this.$router.push({ name: "purchaserequisitiontotal" });
          }, 500);
          // this.$router.go(-1);
        })
        .catch((error) => {
          this.ApproveLoading = false;
          this.$notification(error.response.data.error, "danger");
        });
    },
    CancelApproval() {
      this.CancelApprovalLoading = true;
      PurchaseRequisitionTotalService.CancelApproval(this.$route.params.id)
        .then((res) => {
          this.CancelApprovalLoading = false;
          this.$notification(this.$t("CancelApprovalSuccess"), "success");
          this.CancelApprovalModal = false;
          setTimeout(() => {
            this.$router.push({ name: "purchaserequisitiontotal" });
          }, 500);
          // this.$router.go(-1);
        })
        .catch((error) => {
          this.CancelApprovalLoading = false;
          this.$notification(error.response.data.error, "danger");
        });
    },
  },
};
</script>

<style>
.tab {
  margin-left: 15px;
}
.CardMain {
  border-radius: 10px;
  border-top: #318ce7 solid 5px;
}
.TableCard {
  border-radius: 10px;
  border-top: #20b2aa solid 5px;
}
.text-right {
  text-align: right;
}
.text-left {
  text-align: left;
}
</style>
